import React from 'react'
import classNames from 'classnames/bind'
import styles from './Pagination.module.scss'
import { ReactComponent as ChevronRight } from 'images/arrows/chevron-right.svg'
import { ReactComponent as ChevronRightDouble } from 'images/arrows/chevron-right-double.svg'
import { ReactComponent as ChevronLeft } from 'images/arrows/chevron-left.svg'
import { ReactComponent as ChevronLeftDouble } from 'images/arrows/chevron-left-double.svg'

const cx = classNames.bind(styles)

const Pagination = ({ currentPage, totalPages, onPageChange, maxPagesToDisplay = 5, padding, margin }) => {
  if (!totalPages || totalPages < 1) return null

  // Inline overrides take precedence over the wrapper's default padding/margin
  // so consumers can adjust spacing for their layout. Only set what's provided.
  const overrideStyle = {
    ...(padding !== undefined && { padding }),
    ...(margin !== undefined && { margin }),
  }

  // Calculate start and end pages depending on currentPage and ensure currentPage is centred where possible i.e currentPage !==
  // 1 or currentPage !== totalPages
  let start = Math.max(1, currentPage - Math.floor(maxPagesToDisplay / 2))
  let end = start + maxPagesToDisplay - 1

  if (end > totalPages) {
    end = totalPages
    start = Math.max(1, end - maxPagesToDisplay + 1)
  }

  const pages = []
  for (let i = start; i <= end; i++) {
    pages.push(i)
  }

  return (
    <div className={cx('pagination')} style={overrideStyle}>
      <button
        className={cx('page')}
        onClick={() => onPageChange(1)}
        disabled={currentPage === 1}
      >
        <ChevronLeftDouble />
      </button>

      <button
        className={cx('page')}
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        <ChevronLeft />
      </button>

      {pages.map((page) => (
        <button
          key={page}
          onClick={() => onPageChange(page)}
          className={cx('page', { active: page === currentPage })}
        >
          {page}
        </button>
      ))}

      <button
        className={cx('page')}
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        <ChevronRight />
      </button>

      <button
        className={cx('page')}
        onClick={() => onPageChange(totalPages)}
        disabled={currentPage === totalPages}
      >
        <ChevronRightDouble />
      </button>
    </div>
  )
}

export default Pagination
